import logo from "@/assets/valiosia-logo.png";

export default function BrandLogo({ className = "", size = "md" }) {
  const sizes = {
    sm: "h-6",
    md: "h-7",
    lg: "h-10",
    xl: "h-16",
  };
  return (
    <img
      data-testid="brand-logo"
      src={logo}
      alt="ValiosIA"
      draggable="false"
      className={`${sizes[size]} w-auto select-none ${className}`}
    />
  );
}
